import React from "react";
import { useImmer } from "use-immer";

import { LoadingButtonProps } from "@mui/lab";
import { ButtonGroup, Grid, Menu, MenuItem } from "@mui/material";

import { IgButton } from "./IgButton";
import { IgIconComponent } from "./IgIconComponent";
import { IgTooltip } from "./IgTooltip";

interface IgSplitButtonProps extends LoadingButtonProps {
  menuOptions: {
    key: string;
    disabledMessage?: string;
    action: () => void;
    hidden?: boolean;
  }[];
}

export const IgSplitButton = (props: IgSplitButtonProps) => {
  const { menuOptions, startIcon, ...rest } = props;
  const [open, setOpen] = useImmer(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = useImmer<null | HTMLElement>(null);

  const [selectedIndex, setSelectedIndex] = useImmer(0);

  const handleClick = () => {
    menuOptions[0].action();
    setOpen(false);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    menuOptions[index].action();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    setAnchorEl(anchorRef.current);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <Grid item sx={{ padding: 0 }}>
      <ButtonGroup disableElevation={true} variant="contained" ref={anchorRef}>
        <IgButton
          {...rest}
          startIcon={startIcon}
          size={"small"}
          variant={"contained"}
          onClick={handleClick}
        >
          {menuOptions[0].key}
        </IgButton>
        <IgButton
          {...rest}
          sx={{ padding: "10px" }}
          variant={"contained"}
          size="small"
          onClick={handleToggle}
        >
          <IgIconComponent color={"white"} />
        </IgButton>
      </ButtonGroup>
      <Menu
        disableScrollLock={true}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        {menuOptions.map((option, index) => (
          <IgTooltip key={option.key} title={option.disabledMessage}>
            <MenuItem
              disabled={!!option.disabledMessage}
              selected={index === selectedIndex}
              sx={{ display: option.hidden ? "none" : "flex" }}
              onClick={(event) => handleMenuItemClick(event, index)}
            >
              {option.key}
            </MenuItem>
          </IgTooltip>
        ))}
      </Menu>
    </Grid>
  );
};
